import esContent from './security.es';

export default {
  ...esContent,
};
